import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const Contact = () => {
  return (
    <>
      <span className="pt-20" id="enquire-now"></span>

      {/* <!-- Content Area --> */}
      <div className="mt-20 pb-5 pb-md-0 ">
        <Container>
          <Row className="justify-content-center pt-2">
            <Col lg="9" xl="8">
              <div className="px-md-15 text-center">
                <h2 className="title gr-text-2 mb-9">Enquire Here</h2>
                <p className="gr-text-8 mb-13">
                  Fill out your details and we will get back to you within 24
                  hours.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row className="justify-content-center">
            <Col md="6" lg="5" xl="6" className="order-md-1 ">
              <div className="login-form bg-white border-gray-3 px-8 pt-8 py-9 shadow-1 rounded-10 z-index-99 mb-9">
                <form
                  name="contact3"
                  method="post"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                >
                  {/* You still need to add the hidden input with the form name to your JSX form */}
                  <input type="hidden" name="form-name" value="contact3" />
                  <Row>
                    <Col xs="12">
                      <div className="form-group mb-7">
                        <label
                          htmlFor="name"
                          className="gr-text-11 font-weight-bold text-blackish-blue"
                        >
                          Full Name:
                        </label>
                        <input
                          className="form-control gr-text-11 border"
                          type="text"
                          id="name"
                          name="name"
                          placeholder="First & Last Name"
                          required
                        />
                      </div>
                    </Col>
                    <Col xs="12">
                      <div className="form-group mb-7">
                        <label
                          htmlFor="name"
                          className="gr-text-11 font-weight-bold text-blackish-blue"
                        >
                          Work Email
                        </label>
                        <input
                          className="form-control gr-text-11 border"
                          type="email"
                          id="email"
                          name="email"
                          placeholder="BestContactEmail@EcomAgency.com.au"
                          required
                        />
                      </div>
                    </Col>
                    <Col xs="12">
                      <div className="form-group mb-7">
                        <label
                          htmlFor="name"
                          className="gr-text-11 font-weight-bold text-blackish-blue"
                        >
                          Phone Number
                        </label>
                        <input
                          className="form-control gr-text-11 border"
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="Best Contact Number"
                          required
                        />
                      </div>
                    </Col>
                    <Col xs="12">
                      <div className="form-group mb-7">
                        <label
                          htmlFor="name"
                          className="gr-text-11 font-weight-bold text-blackish-blue"
                        >
                          Website
                        </label>
                        <input
                          className="form-control gr-text-11 border"
                          type="url"
                          id="ecommerce-store-url"
                          name="ecommerce-store-url"
                          placeholder="Your Ecommerce Store URL"
                        />
                      </div>
                    </Col>
                    <Col xs="12">
                      <div className="form-group mb-7">
                        <label
                          htmlFor="name"
                          className="gr-text-11 font-weight-bold text-blackish-blue"
                        >
                          Monthly Marketing Budget
                        </label>
                        <select
                          className="form-control gr-text-11 border"
                          id="monthly-marketing-budget"
                          name="monthly-marketing-budget"
                          placeholder="Monthly Marketing Budget"
                          required
                        >
                          <option disabled>Please Select</option>
                          <option value="5000">Less Than $5,000</option>
                          <option value="5000-15000">$5,000-15,000</option>
                          <option value="15000-50000">$15,000-50,000</option>
                          <option value="50000">$50,000+</option>
                        </select>
                      </div>
                    </Col>

                    <Col xs="12">
                      <div className="form-group mb-7">
                        <label
                          htmlFor="name"
                          className="gr-text-11 font-weight-bold text-blackish-blue"
                        >
                          Message
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          placeholder="Your Business Goals & Services Required"
                          className="form-control gr-text-11 border-gray-3 gr-textarea-height"
                          required
                        ></textarea>
                      </div>
                    </Col>
                    <Col xs="12">
                      <div className="button-block mt-3 ">
                        <Button
                          className="form-btn btn btn-primary w-100"
                          type="submit"
                        >
                          Send
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Contact;
